"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCustomDataPlaceholders22 = exports.getFilteredCustomDataList = exports.getCustomDataList = void 0;

var _reselect = require("reselect");

var _gift = require("../gift/gift.selector");

var getCustomDataList = (0, _reselect.createSelector)(_gift.getGiftRecipient, _gift.getGiftLandingPage, _gift.getGiftSender, _gift.getGiftProduct, function (recipient, landingPage, sender, product) {
  return [{
    placeholder: 'my-first-name',
    value: sender.first_name,
    label: 'Sender first name'
  }, {
    placeholder: 'my-last-name',
    value: sender.last_name,
    label: 'Sender last name'
  }, {
    placeholder: 'company',
    value: sender.company,
    label: 'Sender company'
  }, {
    placeholder: 'first-name',
    value: recipient.first_name,
    label: 'Contact first name'
  }, {
    placeholder: 'last-name',
    value: recipient.last_name,
    label: 'Contact last name'
  }, {
    placeholder: 'recipient-company',
    value: recipient.company,
    label: 'Contact company'
  }, {
    placeholder: 'gift-name',
    value: product === null || product === void 0 ? void 0 : product.name,
    label: 'Gift name'
  }, {
    placeholder: 'product-brand',
    value: product === null || product === void 0 ? void 0 : product.vendor_name,
    label: 'Product brand'
  }, {
    placeholder: 'gl',
    value: landingPage,
    label: 'Gift link'
  }];
}); // todo: make xhr request for custom fields and use it evrywhere

exports.getCustomDataList = getCustomDataList;
var getFilteredCustomDataList = (0, _reselect.createSelector)(getCustomDataList, function (customData) {
  return customData.filter(function (data) {
    return data.value;
  });
});
exports.getFilteredCustomDataList = getFilteredCustomDataList;
var getCustomDataPlaceholders22 = (0, _reselect.createSelector)(getCustomDataList, function (customData) {
  return customData.filter(function (data) {
    return data.value;
  });
});
exports.getCustomDataPlaceholders22 = getCustomDataPlaceholders22;